<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <HxHeader
        id="header-demo"
        :header-text="
          headerText.slice(
            0,
            numberOfWords === 'h1'
              ? 12
              : numberOfWords === 'h1 with chips next line'
                ? 41
                : numberOfWords === 'h2'
                  ? 86
                  : 138
          )
        "
        :breadcrumb-items="isSelected ? items : items.slice(0, 3)"
        :chips="showChips ? chips : []"
        :tooltip-location="tooltipLocation"
      />
      <template #configuration>
        <div class="d-flex flex-column mt-16">
          <hx-checkbox v-model="isSelected" :label="`More Items: ${isSelected}`"></hx-checkbox>
          <hx-checkbox v-model="showChips" :label="`Show chips: ${showChips}`"></hx-checkbox>
          <v-select
            v-model="numberOfWords"
            :items="['h1', 'h1 with chips next line', 'h2', 'truncate']"
            label="Number of words"
            class="my-2"
          ></v-select>
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>
<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixHeader',
  components: { UsageExample },
  setup() {
    const code = `
<hx-header
      id="header-demo"
      :header-text="'Helix Header'"
      :breadcrumb-items="[
        {
          text: 'Home',
          key: 'Home',
          to: '/',
          disabled: false
        },
        {
          text: 'Student Duty of Care',
          key: 'Student Duty of Care',
          to: '/',
          disabled: false
        }
      ]"
      :chips="[
          { label: 'All', color: 'pink', leftIcon: 'mdi-triangle' },
          { label: 'Active', color: 'green' }
        ]"
      :tooltip-location="'top'"
/>
    `;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Header Usage',
      tabs: ['Header Usage'],
      isSelected: true,
      showChips: true,
      items: [
        {
          text: 'Home',
          key: 'Home',
          to: '/',
          disabled: false
        },
        {
          text: 'Student Duty of Care',
          key: 'Student Duty of Care',
          to: '/',
          disabled: false
        },
        {
          text: 'Executive Summary',
          key: 'Executive Summary',
          to: '/module/276/page/ReadMe.md',
          disabled: false
        },
        {
          text: 'Contextualisation Guide',
          key: 'Contextualisation Guide',
          to: '/module/276/page/abc.md',
          disabled: false
        }
      ],
      headerText:
        'Helix Header - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      numberOfWords: 'h1',
      chips: [
        { label: 'All', color: 'pink', leftIcon: 'mdi-triangle' },
        { label: 'Active', color: 'green' },
        { label: 'Inactive', color: 'grey' },
        { label: 'Pending', color: 'yellow' },
        { label: 'Completed', color: 'blue' },
        { label: 'Archived', color: 'red' }
      ],
      tooltipLocation: 'top'
    };
  }
};
</script>
